export default "__VITE_ASSET__DCIpqsVj__"